module.exports = __webpack_public_path__ + "site-build/img/brand_banner.5fe3805f.png";